import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxButtonModule } from '../button/phx-button.module';
import { PhxMenuButtonModule } from '../button-menu/phx-menu-button.module';
import { PhxSplitButtonComponent } from './phx-split-button.component';


@NgModule({
  declarations: [
    PhxSplitButtonComponent
  ],
  imports: [
    CommonModule,
    PhxButtonModule,
    PhxMenuButtonModule,
  ],
  exports: [
    PhxSplitButtonComponent
  ]
})
export class PhxSplitButtonModule { }
